import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const dextDropdownViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map